import { FieldSharedConfigs } from "../../FieldSharedConfigs.js";
import "react";
import { FormLayout, Radio, Text } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/Label/Config.tsx
var LabelFieldConfig = ({ config, setOptionsKey, ...rest }) => {
	return /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsxs(FormLayout, {
		space: "sm",
		children: [
			/* @__PURE__ */ jsx(Text, {
				onChangeValue: (value) => setOptionsKey("label", value),
				label: "Title",
				value: config.options.label
			}),
			/* @__PURE__ */ jsx(Text, {
				onChangeValue: (value) => setOptionsKey("subText", value),
				label: "Sub Text",
				value: config.options.subText
			}),
			/* @__PURE__ */ jsx(Radio, {
				label: "Font Size",
				options: [
					{
						label: "Small",
						value: "sm"
					},
					{
						label: "Regular",
						value: "base"
					},
					{
						label: "Large",
						value: "lg"
					},
					{
						label: "X-Large",
						value: "xl"
					}
				],
				onChangeValue: (val) => setOptionsKey("fontSize", val),
				value: config.options.fontSize
			})
		]
	}), /* @__PURE__ */ jsx(FieldSharedConfigs, {
		config,
		setOptionsKey,
		...rest
	})] });
};
//#endregion
export { LabelFieldConfig };

//# sourceMappingURL=Config.js.map